<template>
    <b-modal id="myPromiseGoodsRegModal" :title="title" size="md">
        <div class="search user_modal">
            <div class="table_list">
                <div class="detail">
                    <div class="title_sm pt0">
                        <h3 class="tb_title">내 약속상품 정보</h3>
                    </div>
                    <table class="write">
                        <colgroup>
                            <col width="100">
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>내약속상품명</th>
                                <td><input type="text" class="form_control" v-model="regInfo.my_promise_goods_nm"></td>
                            </tr>
                            <tr>
                                <th>제조수량</th>
                                <td><input type="number" class="form_control" v-model.number="regInfo.produce_quantity"></td>
                            </tr>
                            <tr>
                                <th>설명</th>
                                <td><input type="text" class="form_control" v-model="regInfo.my_promise_goods_source"></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                 <h3 class="tb_title pb20 pt20">약재 정보</h3>
                <table class="write">
                    <colgroup>
                        <col width="*">
                        <col width="120">
                        <col width="100">
                    </colgroup>
                    <thead>                
                        <tr>                                
                            <th class="bn ac">약재명</th>
                            <th class="bn ac">제약회사</th>
                            <th class="bn ac">원산지</th>
                            <th class="bn ac">첩량</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in myPromiseGoodsMedList" :key="index">
                            <td class="ac"><span>{{item.med_hrb_nm}}</span></td>
                            <td class="ac"><span>{{item.company_nm}}</span></td>
                            <td class="ac"><span>{{item.org_plce_nm}}</span></td>
                            <td class="ac"><span>{{item.med_use_qnty}}</span></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <template #modal-footer="{ ok }">
            <b-button @click="fn_reg_confirm()" class="btn btn_md btn_brown">저장</b-button>
            <b-button @click="ok" class="btn btn_md btn_brown">닫기</b-button>
        </template>
        <AlertModal 
            :id="'alert'"
            :text="'저장되었습니다.'" 
            :btnRight="'확인'" 
            :oneBtn="false"
            :isShow="alertShow"
            :className="'btn_brown'"
            @callback="fn_alert_close"
        /> 
        <AlertModal 
            :id="'confirm'"
            :text="'저장하시겠습니까?'" 
            :btnLeft="'취소'" 
            :btnRight="'확인'" 
            :oneBtn="true"
            :isShow="comfirmAlertShow"
            :className="'btn_brown'"
            @callback="fn_alert_close"
        />
    </b-modal>

</template>

<script>
    import AlertModal from "@/modal/admin/alertModal.vue"
    import axios from 'axios'

    export default {
        name: 'myPromiseGoodsRegModal',
        components: {
            AlertModal    
        },
        props: {
            title: String,
            myPromiseGoodsMedList : [],
            produce_quantity : Number
        },
        watch : {
            produce_quantity(value){
                this.regInfo.produce_quantity = value;
            }
        },
        methods: {
            fn_reg_confirm(){

                if(this.regInfo.my_promise_goods_nm == '' ){
                    alert("내 약속상품명을 입력해주세요");
                    return;
                }

                if(this.regInfo.produce_quantity == 0 ){
                    alert("제조수량을 입력해주세요");
                    return;
                }

                this.comfirmAlertShow = true;
            },
            fn_alert_close(type){
                
                console.log("@@@@ type : "+type);
                console.log("@@@@ regInfo : %o",this.regInfo);

                if(type == 'hide'){
                    this.comfirmAlertShow = false;                       
                }else if(type == 'ok'){
                    this.comfirmAlertShow = false;
                
                    axios
                        .post("/api/admin/promiseGoodsWrhs/regMyPromiseGoods", this.regInfo)
                        .then((res) => {
                            this.alertShow = true;
                        })
                        .catch((err) => console.log(err));

                        this.$emit('callback', this.regInfo.produce_quantity);
                        this.$bvModal.hide("myPromiseGoodsRegModal"); 

                    }else if(type == 'close'){
                        this.alertShow = false;

                        this.$emit('callback', this.regInfo.produce_quantity);
                        this.$bvModal.hide("myPromiseGoodsRegModal"); 
                    }

                    
            },                      
        },
        data () {
            return {
                comfirmAlertShow : false,
                alertShow : false,
                regInfo : {
                    my_promise_goods_nm : '',
                    my_promise_goods_source : '',
                    produce_quantity : this.produce_quantity,
                    medicinelist : this.myPromiseGoodsMedList
                }
            }
        }
    }
</script>
